import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const cropperContainer: CSSProperties = {
  position: 'relative',
  width: '100%',
  height: 'calc(100vh - 140px)',
  paddingTop: '50px',
  background: UIConfig.Colors.BackgroundWhite,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  zIndex: 999999999
};

export const cropperWrapper: CSSProperties = {
  position: 'relative',
  flex: 1,
  background: '#fff'
};

export const cropperButtons: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '10px',
  padding: '16px 16px 32px',
  background: 'transparent'
};

export const btn: CSSProperties = {
  fontSize: '16px',
  padding: '12px 24px',
  border: 'none',
  width: '50%',
  cursor: 'pointer',
  borderRadius: '10px',
  minHeight: '48px'
};

export const btnContent: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const btnCancel: CSSProperties = {
  background: '#eee',
  color: 'black'
};

export const btnConfirm: CSSProperties = {
  fontWeight: 600,
  background: '#000',
  color: 'white'
};
